import { Images, Videos } from "components";
import { useAppointmentLocation } from "modules/AppointmentDetails/hooks";

import type { Appointment, QuestionResult } from "models";

type QuestionResultMediaProps = {
  appointment: Appointment;
  questionResult: QuestionResult;
};

export const QuestionResultMedia = ({ appointment, questionResult }: QuestionResultMediaProps) => {
  const appointmentLocation = useAppointmentLocation(appointment);
  const images = questionResult.images?.filter(item => item.active) || [];
  const videos = questionResult.videos?.filter(item => item.active) || [];

  return (
    <div className="checklist-media">
      <Images images={images} canDelete={false} />
      <Videos appointment={appointment} location={appointmentLocation} videos={videos} isEditable={false} />
    </div>
  );
};
